import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as Actions from '@app/core/store/games/games-actions';
import { selectGames, selectGamesLoaded } from '@app/core/store/games/games-selectors';
import { Observable } from 'rxjs';
import { Game } from '@app/games/model/game';

@Injectable()
export class GamesService {
  constructor(private store: Store) {
  }

  public getGames(): Observable<Game[]> {
    return this.store.select(selectGames);
  }

  public isGamesLoaded(): Observable<boolean> {
    return this.store.select(selectGamesLoaded);
  }

  public loadGames(language: string): void {
    this.store.dispatch(Actions.loadGames({ language }));
  }

}
